import { createAction, props } from '@ngrx/store';
import { UdfGroup } from '@feature/_app_modules/additional-information/models/UdfGroups';
import { EntityKey } from '@feature/pma-document-centre/pma-document-centre-types';

const tag = '[Additional Information Available Groups]';

export const loadAvailableGroups = createAction(
  `${tag} Load Available Groups`,
  props<{
    key: EntityKey,
    widgetConfigId: number;
  }>());

export const loadAvailableGroupsComplete = createAction(
  `${tag} Load Available Groups Complete`,
  props<{
    widgetConfigId: number,
    availableGroups: UdfGroup[];
  }>());
